<template>
	<div class="dialog">
		<slot v-bind="{ onSubmit }" />
	</div>
</template>

<script setup>
	import { ref } from 'vue';

	const isVisible = ref(false);
	function onSubmit() {
			isVisible.value = false;
	}
</script>

<style scoped>
	.dialog {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0,0,0,0.3);
		z-index: 1;
	}
</style>